// extracted by mini-css-extract-plugin
export default {"skeleton_container":"SuggestionSkeleton_skeleton_container__Ni4gY","skeleton_item":"SuggestionSkeleton_skeleton_item__OUa98","shine":"SuggestionSkeleton_shine__lAP3v"};